import { BlocksTitle } from '@components/Blocks/shared/BlocksTitle';
import { Maybe } from '@lib/types/Maybe';
import { ArrowRight } from 'phosphor-icons';

export const ProductRowHeading = ({
  title,
  description,
  text,
  textPlain,
  link,
  onLinkClick,
}: {
  title: Maybe<string>;
  description?: string | null; // HTML string
  text?: string | null; // HTML string
  textPlain?: string | null; // Plain text for aria-label
  link?: { href: string; label: string };
  onLinkClick?: (label: string) => void;
}) => {
  const linkAriaLabelFallbackText = textPlain ?? '';

  let linkAriaLabel = link?.label ?? '';

  if (title) {
    linkAriaLabel += ` ${title}`;
  } else if (linkAriaLabelFallbackText) {
    linkAriaLabel += ` ${linkAriaLabelFallbackText}`;
  }

  return (
    <div className="container mb-4 flex justify-end">
      {(title || description || text) && (
        <div className="mr-auto">
          <BlocksTitle title={title} description={description} text={text} />
        </div>
      )}
      {link && (
        <a
          data-test="product-row-heading-link"
          href={link.href}
          className="ml-4 flex flex-shrink-0 items-center self-end text-blue"
          onClick={() => onLinkClick && onLinkClick(link.label)}
          aria-label={linkAriaLabel}
        >
          {link.label}
          <ArrowRight className="ml-1 inline-block" />
        </a>
      )}
    </div>
  );
};
